export default __webpack_public_path__ + "static/resource-block_princeton-c189c004d14075db27ad72591de0d9dc.jpg";